<!-- HomeAbout.vue -->
<template>
  <div class="home-about"
    :class="[deviceType === 'mobile' ? 'detect_deviece_mobile' : 'detect_deviece_pc']">
    <div class="about-section">
      <div class="about-header">
        <div class="header-title">About Us</div>
        <div class="header-desc">Welcome to {{ domainConfig?.siteName }}, your trusted partner in
          navigating
          the world of auto financing. Our mission is to empower you with the tools and information
          you need to make informed decisions about your vehicle purchases.</div>
        <div class="header-line"></div>
      </div>
      <div class="who-we-are">
        <img src="@/assets/about.png" alt="Happy person" class="who-we-are-image" />
        <div class="who-we-are-content">
          <div class="who-we-are-title">Who We Are</div>
          <div class="who-we-are-desc">At {{ domainConfig?.siteName }}, we specialize in connecting
            you with
            reputable auto loan lenders offering competitive rates, even if you have
            less-than-perfect credit. Our team is dedicated to simplifying the auto loan process,
            ensuring you find the best financing options tailored to your needs.</div>
        </div>
      </div>
    </div>
    <div class="offers-section">
      <div class="offers-title">What We Offer</div>
      <div class="offer-cards">
        <div class="offer-card">
          <div class="card-header">
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" class="offer-icon" viewBox="0 0 36 36"
                fill="none">
                <path
                  d="M32.2269 0H22.796C20.7122 0 19.0229 1.68929 19.0229 3.77312V13.2039C19.0229 15.2877 20.7122 16.977 22.796 16.977H32.2269C34.3107 16.977 36 15.2877 36 13.2039V3.77316C36 1.68929 34.3107 0 32.2269 0ZM32.4806 9.62056H22.5423C21.9172 9.62056 21.4104 9.11371 21.4104 8.48861C21.4104 7.8635 21.9172 7.35666 22.5423 7.35666H32.4806C33.1057 7.35666 33.6125 7.8635 33.6125 8.48861C33.6125 9.11371 33.1057 9.62056 32.4806 9.62056ZM32.1998 19.0268H22.7883C20.7088 19.0268 19.0229 20.7126 19.0229 22.7922V32.2038C19.0229 34.2834 20.7088 35.9692 22.7883 35.9692H32.1999C34.2795 35.9692 35.9653 34.2834 35.9653 32.2038V22.7922C35.9653 20.7126 34.2795 19.0268 32.1998 19.0268ZM27.4911 22.8527H27.495C28.1188 22.8527 28.6246 23.3585 28.6246 23.9823C28.6246 24.6062 28.1188 25.1119 27.495 25.1119C26.8712 25.1119 26.3635 24.6062 26.3635 23.9823C26.3635 23.3585 26.8673 22.8527 27.4911 22.8527ZM27.495 32.1942C26.8712 32.1942 26.3635 31.6884 26.3635 31.0646C26.3635 30.4408 26.8673 29.935 27.4911 29.935H27.495C28.1188 29.935 28.6246 30.4408 28.6246 31.0646C28.6246 31.6884 28.1188 32.1942 27.495 32.1942ZM32.453 28.6277H22.5352C21.9114 28.6277 21.4056 28.1219 21.4056 27.4981C21.4056 26.8742 21.9114 26.3684 22.5352 26.3684H32.453C33.0769 26.3684 33.5827 26.8742 33.5827 27.4981C33.5827 28.1219 33.0769 28.6277 32.453 28.6277ZM13.1825 0H3.76706C1.68656 0 0 1.68655 0 3.76704V13.1826C0 15.2631 1.68656 16.9496 3.76706 16.9496H13.1825C15.263 16.9496 16.9495 15.2631 16.9495 13.1826V3.76704C16.9495 1.68655 15.263 0 13.1825 0ZM13.4357 9.60501H9.60487V13.4359C9.60487 14.06 9.09887 14.566 8.47476 14.566C7.85066 14.566 7.34466 14.06 7.34466 13.4359V9.60501H3.51378C2.88967 9.60501 2.38367 9.09902 2.38367 8.47491C2.38367 7.85081 2.88967 7.34482 3.51378 7.34482H7.34466V3.51396C7.34466 2.88986 7.85066 2.38386 8.47476 2.38386C9.09887 2.38386 9.60487 2.88986 9.60487 3.51396V7.34482H13.4357C14.0599 7.34482 14.5659 7.85081 14.5659 8.47491C14.5659 9.09902 14.0599 9.60501 13.4357 9.60501ZM13.2036 19.1451H3.84087C1.77205 19.1451 0.0949104 20.8222 0.0949104 22.891V32.2541C0.0949104 34.3229 1.77205 36 3.84087 36H13.2036C15.2724 36 16.9495 34.3229 16.9495 32.2541V22.891C16.9495 20.8222 15.2724 19.1451 13.2036 19.1451ZM12.805 30.2664C13.244 30.7052 13.244 31.4167 12.805 31.8555C12.5857 32.075 12.298 32.1847 12.0104 32.1847C11.7229 32.1847 11.4352 32.075 11.2159 31.8555L8.52212 29.1617L5.82835 31.8555C5.60905 32.075 5.32134 32.1847 5.03379 32.1847C4.74624 32.1847 4.45853 32.075 4.23923 31.8555C3.80024 31.4167 3.80024 30.7052 4.23923 30.2664L6.933 27.5726L4.23923 24.8789C3.80024 24.4401 3.80024 23.7286 4.23923 23.2898C4.67787 22.8508 5.38971 22.8508 5.82835 23.2898L8.52212 25.9835L11.2159 23.2898C11.6545 22.8508 12.3664 22.8508 12.805 23.2898C13.244 23.7286 13.244 24.4401 12.805 24.8789L10.1112 27.5726L12.805 30.2664Z"
                  fill="#05C8E8" />
              </svg>
            </div>
            <div class="card-title">Comprehensive<br />Calculators</div>
          </div>
          <div class="card-desc">Our easy-to-use calculators help you estimate loan payments,
            compare leasing options, and determine the total cost of car ownership.</div>
        </div>
        <div class="offer-card">
          <div class="card-header">
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" class="offer-icon" viewBox="0 0 36 36"
                fill="none">
                <path
                  d="M18 0C13.2261 0 8.64773 1.89583 5.27208 5.27042C1.89642 8.64501 0 13.2219 0 17.9943C0 20.5698 0.558 23.017 1.53225 25.2303C1.55475 25.273 1.61775 25.3158 1.61775 25.3585V25.3855C2.11725 26.4022 2.61675 27.3716 3.11625 28.2781V33.5954H8.94825C10.017 34.0948 11.1532 34.7111 12.348 35.1069C14.1722 35.7044 16.0804 36.0058 18 35.9999C25.4587 35.9999 31.86 31.4563 34.5915 24.9941C35.524 22.7799 36.003 20.4013 36 17.9988C36.0003 15.6355 35.5349 13.2952 34.6305 11.1117C33.7261 8.92811 32.4003 6.94401 30.7288 5.27267C29.0574 3.60132 27.073 2.27545 24.889 1.37077C22.705 0.466083 20.3641 0.000295363 18 0ZM17.7907 28.5795C17.5802 28.5792 17.3718 28.5375 17.1774 28.4566C16.983 28.3758 16.8065 28.2575 16.6578 28.1085C16.3576 27.8075 16.1893 27.3997 16.1899 26.9746C16.1905 26.5496 16.3599 26.1422 16.661 25.8421C16.9621 25.5419 17.3701 25.3737 17.7952 25.3743C18.2204 25.3749 18.6279 25.5443 18.9282 25.8452C19.2284 26.1462 19.3967 26.5541 19.3961 26.9791C19.3955 27.4042 19.226 27.8116 18.925 28.1117C18.6239 28.4118 18.2159 28.5801 17.7907 28.5795ZM19.8922 19.2832C19.836 19.3012 19.5975 19.4271 19.548 19.5306C19.4715 19.6948 19.4175 19.9355 19.386 20.1716C19.359 20.3516 19.395 21.0331 19.395 21.1771C19.4061 21.5858 19.2603 21.9832 18.9874 22.2878C18.7145 22.5923 18.3353 22.7807 17.9277 22.8144C17.5201 22.8481 17.1151 22.7245 16.7958 22.4689C16.4766 22.2133 16.2674 21.8452 16.2112 21.4402C16.1955 21.2457 16.1895 21.0505 16.1932 20.8554C16.1955 20.3201 16.2045 19.2584 16.2157 18.7433C16.2253 18.5481 16.2509 18.3541 16.2922 18.163C16.5892 17.1149 17.3317 16.6178 17.9685 16.3816C18.1755 16.3051 18.747 16.1522 18.9495 16.0779C19.5572 15.8591 20.0679 15.4324 20.3911 14.8733C20.7143 14.3142 20.8292 13.6589 20.7155 13.0232C20.6018 12.3876 20.2668 11.8126 19.7698 11.4002C19.2729 10.9877 18.6459 10.7644 18 10.7696C16.596 10.7696 15.435 11.8223 15.2775 13.1831C15.224 13.5628 15.1594 13.9408 15.084 14.3167C14.9911 14.6357 14.7972 14.9159 14.5315 15.1155C14.2658 15.315 13.9426 15.423 13.6102 15.4234C13.3599 15.4238 13.1132 15.3625 12.8922 15.2448C12.6713 15.1271 12.4828 14.9566 12.3435 14.7486C12.0649 14.3335 11.9118 13.847 11.9025 13.3473C11.9453 11.7587 12.6063 10.2494 13.745 9.14041C14.8837 8.03146 16.4103 7.41035 18 7.40917C18.8009 7.40917 19.594 7.56691 20.3339 7.87338C21.0739 8.17985 21.7461 8.62905 22.3124 9.19532C22.8786 9.76158 23.3277 10.4338 23.634 11.1736C23.9403 11.9134 24.0978 12.7063 24.0975 13.507C24.0969 14.7908 23.6894 16.0413 22.9334 17.0791C22.1775 18.1169 21.112 18.8885 19.89 19.2832H19.8922Z"
                  fill="#05C8E8" />
              </svg>
            </div>
            <div class="card-title">Expert<br />Guidance</div>
          </div>
          <div class="card-desc">We provide insightful resources and expert advice to help you
            understand your financing options and make confident decisions.</div>
        </div>
        <div class="offer-card">
          <div class="card-header">
            <div class="icon-container">
              <svg xmlns="http://www.w3.org/2000/svg" class="offer-icon" viewBox="0 0 36 36"
                fill="none">
                <path
                  d="M33.8164 11.6383L23.2721 16.9111C20.3603 18.3672 15.6396 18.3672 12.7278 16.9111L2.18387 11.6383C-0.727957 10.1823 -0.727957 7.82149 2.18387 6.36482L12.7278 1.09201C15.6396 -0.364002 20.3603 -0.364002 23.2721 1.09201L33.8164 6.36482C36.7279 7.82149 36.7279 10.1821 33.8164 11.6383ZM23.2721 25.9094C20.3603 27.3654 15.6396 27.3654 12.7278 25.9094L2.18387 20.6368C-0.481943 19.3028 -0.706658 17.2116 1.50897 15.7503C1.72522 15.8922 1.95061 16.0215 2.18387 16.1375L12.7278 21.4104C15.6396 22.8664 20.3603 22.8664 23.2721 21.4104L33.8164 16.1375C34.0495 16.0215 34.2748 15.8922 34.4909 15.7503C36.7066 17.2116 36.4823 19.3028 33.8164 20.6367L23.2721 25.9094ZM1.50897 24.7488C1.7253 24.8906 1.95069 25.0198 2.18387 25.1358L12.7278 30.4087C15.6396 31.8647 20.3603 31.8647 23.2721 30.4087L33.8164 25.1358C34.0495 25.0198 34.2747 24.8906 34.4909 24.7488C36.7066 26.2099 36.4823 28.3015 33.8164 29.635L23.2721 34.9079C20.3603 36.364 15.6396 36.364 12.7278 34.9079L2.18387 29.6349C-0.481943 28.3014 -0.706658 26.2099 1.50897 24.7488Z"
                  fill="#05C8E8" />
              </svg>
            </div>
            <div class="card-title">Personalized<br />Solutions</div>
          </div>
          <div class="card-desc">Whether you're buying or leasing, we work with a network of lenders
            to offer solutions that fit your financial situation.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeAbout',
  computed: {
    ...mapGetters([
      'deviceType', "domainConfig"
    ])
  }
}
</script>

<style lang="scss" >
@import '~@/css/variables.scss';

/* 为SVG图标应用主题色 */
.offer-icon path {
	fill: var(--theme-primary);
}

.home-about {
	padding: 0 rem(120) rem(80) rem(120);
	display: flex;
	flex-direction: column;
	gap: rem(52);
	align-items: center;
	justify-content: flex-start;
	position: relative;

	.detect_deviece_mobile & {
		padding: 0 rem(16) rem(40) rem(16);
		gap: rem(32);
	}
}

.about-section {
	display: flex;
	flex-direction: column;
	gap: rem(28);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;

	.detect_deviece_mobile & {
		gap: rem(20);
	}
}

.about-header {
	border-radius: rem(24);
	display: flex;
	flex-direction: column;
	gap: 0;
	align-items: center;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
	padding: 0 rem(120);

	.detect_deviece_mobile & {
		padding: 0 rem(16);
	}
}

.header-title {
	color: #1a4048;
	text-align: center;
	font-size: rem(32);
	line-height: rem(32);
	font-weight: 900;
	position: relative;
	align-self: stretch;
	margin-bottom: rem(20);
}

.header-desc {
	color: #1a4048;
	text-align: center;
	font-size: rem(16);
	line-height: rem(20);
	font-weight: 400;
	position: relative;
	margin-bottom: rem(20);
}

.header-line {
	background: var(--theme-primary);
	border-radius: rem(100);
	width: rem(36);
	height: rem(4);
	position: relative;
}

.who-we-are {
	background: var(--theme-primary);
	border-radius: rem(24);
	padding: 0 rem(120);
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: rem(300);
	position: relative;

	.detect_deviece_mobile & {
		flex-direction: column;
		padding: rem(36) 0 0;
		height: auto;
		gap: rem(20);
	}
}

.who-we-are-image {
	flex-shrink: 0;
	width: rem(360);
	height: rem(300);
	position: relative;
	object-fit: cover;
	border-radius: rem(24) 0 0 rem(24);

	.detect_deviece_mobile & {
		width: 100%;
		height: rem(286);
		order: 2;
		border-radius: rem(24) rem(24) 0 0;
	}
}

.who-we-are-content {
	display: flex;
	flex-direction: column;
	gap: rem(32);
	align-items: center;
	justify-content: flex-start;
	width: rem(520);
	position: relative;

	.detect_deviece_mobile & {
		width: 100%;
		order: 1;
		padding: 0 rem(16);
	}
}

.who-we-are-title {
	color: #ffffff;
	text-align: center;
	font-size: rem(60);
	line-height: rem(60);
	font-weight: 900;
	position: relative;
	align-self: stretch;

	.detect_deviece_mobile & {
		font-size: rem(36);
		line-height: rem(40);
	}
}

.who-we-are-desc {
	color: #ffffff;
	text-align: center;
	font-size: rem(16);
	line-height: rem(20);
	font-weight: 400;
	position: relative;
	align-self: stretch;
}

.offers-section {
	display: flex;
	flex-direction: column;
	gap: rem(32);
	align-items: flex-start;
	justify-content: flex-start;
	align-self: stretch;
	position: relative;
}

.offers-title {
	color: #1a4048;
	text-align: center;
	font-size: rem(32);
	line-height: rem(32);
	font-weight: 900;
	position: relative;
	align-self: stretch;
}

.offer-cards {
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
	align-self: stretch;
	position: relative;

	.detect_deviece_mobile & {
		flex-direction: column;
		gap: rem(20);
	}
}

.offer-card {
	background: linear-gradient(180deg, var(--theme-primary-light) 0%, rgba(255, 255, 255, 0) 50%, rgba(255, 255, 255, 0) 100%);
	border-radius: rem(24);
	border: 1px solid #e5e7eb;
	padding: rem(36);
	display: flex;
	flex-direction: column;
	gap: rem(20);
	align-items: flex-start;
	justify-content: flex-start;
	width: rem(380);
	position: relative;

	.detect_deviece_mobile & {
		width: 100%;
	}
}

.card-header {
	display: flex;
	flex-direction: row;
	gap: rem(20);
	align-items: center;
	justify-content: flex-start;
	position: relative;
}

.icon-container {
	width: rem(60);
	height: rem(60);
	position: relative;
	background: #ffffff;
	border-radius: rem(16);
	border: 2px solid var(--theme-primary);
	display: flex;
	align-items: center;
	justify-content: center;
}

.offer-icon {
	width: rem(36);
	height: rem(36);
}

.card-title {
	color: #1a4048;
	text-align: left;
	font-size: rem(24);
	line-height: rem(28);
	font-weight: 700;
	position: relative;
}

.card-desc {
	color: #1a4048;
	text-align: left;
	font-size: rem(14);
	line-height: rem(20);
	font-weight: 400;
	position: relative;
	align-self: stretch;
}
</style> 